<template>
  <v-app id="app">
    <!-- <v-app-bar app color="primary" dark class="bg_toolbar" height="70px">
      <div class="Rectangle ">
        <div class="bg_logo">
          <v-img
            :src="require('./assets/royin-logo2.png')"
            max-width="40"
          ></v-img>
        </div>
      </div>
      <v-toolbar-title
        ><h2>ระบบฐานข้อมูลคำทับศัพท์ของสำนักงานราชบัณฑิตยสภา</h2>
      </v-toolbar-title>
    </v-app-bar> -->

    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>
